import { useCallback, useState } from "react";
import { Outlet, useNavigation } from "react-router";

import { MobileNav } from "@/components/layout/mobile-nav";
import { Sidebar } from "@/components/layout/sidebar";
import { Topbar } from "@/components/layout/topbar";

export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigation = useNavigation();
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <div className="min-h-screen bg-[#f5f6fa] text-[#1f2433] dark:bg-[#101315] dark:text-white">
      {navigation.state === "loading" ? (
        <div className="fixed inset-x-0 top-0 z-[90] h-0.5 animate-pulse bg-[#4077f6]" role="progressbar" />
      ) : null}
      <div className="grid min-h-screen xl:grid-cols-[310px_1fr]">
        <Sidebar />
        <div className="min-w-0">
          <Topbar onOpenMenu={() => setMenuOpen(true)} />
          <main className="p-4 sm:p-6 lg:p-8">
            <Outlet />
          </main>
        </div>
      </div>
      <MobileNav onClose={closeMenu} open={menuOpen} />
    </div>
  );
}
